module.exports = __webpack_public_path__ + "images/for_companies_lp/logo_mynavinews_b40f1630d4250e8e6dc8b9ae63b8311d.jpg";